var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint0_linear_4206_8103)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 150H30.5V53C34.742 52.9952 38.8089 51.308 41.8084 48.3085C44.808 45.3089 46.4952 41.242 46.5 37H104.5C104.496 39.1014 104.908 41.1828 105.713 43.1238C106.518 45.0648 107.7 46.8268 109.191 48.308C110.672 49.7991 112.434 50.9816 114.375 51.787C116.317 52.5924 118.398 53.0047 120.5 53V150Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7 72.7998H59.9C57.4699 72.7998 55.5 74.7698 55.5 77.1998V92.5998C55.5 95.0299 57.4699 96.9998 59.9 96.9998H90.7C93.1301 96.9998 95.1 95.0299 95.1 92.5998V77.1998C95.1 74.7698 93.1301 72.7998 90.7 72.7998Z",
    stroke: "#4F46E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3008 72.8V64C64.3008 61.0826 65.4597 58.2847 67.5226 56.2218C69.5855 54.1589 72.3834 53 75.3008 53C78.2182 53 81.0161 54.1589 83.079 56.2218C85.1419 58.2847 86.3008 61.0826 86.3008 64V72.8",
    stroke: "#4F46E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 108H62.5C60.8431 108 59.5 109.343 59.5 111C59.5 112.657 60.8431 114 62.5 114H88.5C90.1569 114 91.5 112.657 91.5 111C91.5 109.343 90.1569 108 88.5 108Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 120H53.5C51.8431 120 50.5 121.343 50.5 123C50.5 124.657 51.8431 126 53.5 126H97.5C99.1569 126 100.5 124.657 100.5 123C100.5 121.343 99.1569 120 97.5 120Z",
    fill: "#DFEAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4206_8103",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.c475d60e60c4b8d2f9b247559177f5e8.svg";
export { ForwardRef as ReactComponent };